export const hasLlpEvent = (shopVisit) => Array.isArray(shopVisit?.events) && shopVisit.events.some((ev) => ev?.maintenance_program?.is_llp_event === true);
export const hasNonLlpEvent = (shopVisit) => Array.isArray(shopVisit?.events) && shopVisit.events.some((ev) => ev?.maintenance_program?.is_llp_event === false);
